module.exports = __webpack_public_path__ + "img/add_product.7af99941.webp";